import { DropdownOption } from '@keplerco/core';
import { AssessmentStatusDescription, AssessmentStatus } from '../../enums/assessment-status';
import { SortByOption, SortByOptionDescription } from '../../enums/sort-by-option';
import { ColumnConfiguration } from '../../models/column-configuration';
import { CompanySkillListItemResponse } from '../../models/overmind/company-entity';
import { AssessmentAssigneeResponse, AssessmentListItemResponse, AssessmentListSearchParams } from '../../overmind/actions';

// TODO: create AssessmentStatusDescription enum
export enum AssessmentManagementTabId {
  All = 'All',
  Active = 'Active',
  Draft = 'Draft',
  Closed = 'Closed',
  Archived = 'Archived',
}

export interface IAssessmentManagementTableProps {
  skillAssessments: AssessmentListItemResponse[];
  searchParams: AssessmentListSearchParams;
  onPageChangeHandler: (page: number) => void;
  onConfigClicked: () => void;
  loadingSkillAssessments: string[];
  columnConfiguration: ColumnConfiguration[];
  totalPages: number;
  onClickManageAssessmentDraftHandler: (data: AssessmentListItemResponse | undefined) => void;
  onClickViewAssessmentOverview: (data: AssessmentListItemResponse | undefined) => void;
  onClickArchiveDraftAssessmentHandler: (data: AssessmentListItemResponse | undefined) => void;
  onClickCompleteHandler: (data: AssessmentListItemResponse | undefined) => void;
  onClickViewAssigneesHandler: (data: AssessmentListItemResponse | undefined) => void;
}

/** @deprecated This will be removed when Group, Questionnaire and FOP Assessments are refactored to the Stepper, do not use. */
export interface IPerson extends AssessmentAssigneeResponse {
  selected: boolean;
  manager: boolean;
  skills: CompanySkillListItemResponse[];
}

export enum FilterType {
  AssessmentStatuses = 'assessmentStatuses',
  AssessmentSubType = 'assessmentSubType',
}

export const STATUS_OPTIONS: DropdownOption[] = [
  { label: AssessmentStatusDescription.Closed, value: AssessmentStatus.Closed.toString() },
  { label: AssessmentStatusDescription.Active, value: AssessmentStatus.Active.toString() },
  { label: AssessmentStatusDescription.Draft, value: AssessmentStatus.Draft.toString() },
  { label: AssessmentStatusDescription.Archived, value: AssessmentStatus.Archived.toString() },
  { label: AssessmentStatusDescription.Scheduled, value: AssessmentStatus.Scheduled.toString() },
];

export const SORT_BY_OPTIONS: DropdownOption[] = [
  {
    value: SortByOption.AlphabeticalAtoZ,
    label: SortByOptionDescription.AlphabeticalAtoZ,
  },
  {
    value: SortByOption.AlphabeticalZtoA,
    label: SortByOptionDescription.AlphabeticalZtoA,
  },
  {
    value: SortByOption.MostRecentlyCreated,
    label: SortByOptionDescription.MostRecentlyCreated,
  },
];

